import { all, call, put, takeLatest, select } from "redux-saga/effects";
import httpClient from "./http-client";
import { fetchConsumerChartsDataFailure,
  fetchConsumerChartsDataSuccess,
  fetchConsumerChartsDataRequested,
  FETCH_CONSUMER_CHARTS_DATA,
  fetchBusinessChartsDataRequested,
  fetchBusinessChartsDataSuccess,
  fetchBusinessChartsDataFailure,
  FETCH_BUSINESS_CHARTS_DATA } from "../actions/analytics-action-types";

export function* fetchConsumerChartsDataHandler() {
  yield put(fetchConsumerChartsDataRequested());

  const userData = yield select((state) => state?.user?.user);
  const userId = userData?.identifier;

  const request = {
    method: "GET",
    url: `/api/v1/analytics/customer/${userId}`,
  };

  const {
    data, error,
  } = yield call(httpClient, request, false);

  if (error) {
    yield put(fetchConsumerChartsDataFailure(error));
  } else {
    yield put(fetchConsumerChartsDataSuccess(data.details));
  }
}

export function* fetchBusinessChartsDataHandler() {
  yield put(fetchBusinessChartsDataRequested());

  const userData = yield select((state) => state?.user?.user);
  const userId = userData?.identifier;

  const request = {
    method: "GET",
    url: `/api/v1/analytics/business/${userId}`,
  };

  const {
    data, error,
  } = yield call(httpClient, request, false);

  if (error) {
    yield put(fetchBusinessChartsDataFailure(error));
  } else {
    yield put(fetchBusinessChartsDataSuccess(data.details));
  }
}

function* Job() {
  yield all([
    takeLatest(FETCH_CONSUMER_CHARTS_DATA, fetchConsumerChartsDataHandler),
    takeLatest(FETCH_BUSINESS_CHARTS_DATA, fetchBusinessChartsDataHandler),
  ]);
}

export default Job;
